import { ButtonGeneric } from "../../componentes/ButtonGeneric/buttonGeneric";

interface ModalButtonsProps {
  buttonOne?: string;
  buttonTwo?: string;
  buttonThree?: string;
  onConfirm?: () => void;
  onClose?: () => void;
  onLogout?: () => void;
  isButtonDisabled?: boolean;
  isSubmitting?: boolean;
}

export const ModalButtons = ({
  buttonOne,
  buttonTwo,
  buttonThree,
  onConfirm,
  onClose,
  onLogout,
  isButtonDisabled,
  isSubmitting,
}: ModalButtonsProps) => {
  return (
    <div className="buttonsEdit">
      {buttonOne && (
        <ButtonGeneric
          style="buttonGenericCustom buttonGeneric buttonHover buttonDisabled"
          title={buttonOne}
          colorTitle="#fff"
          onClick={onConfirm}
          disabled={isButtonDisabled || isSubmitting}
        />
      )}
      {buttonTwo && (
        <ButtonGeneric
          style="buttonGenericCustom"
          title={buttonTwo}
          colorTitle="#007BC0"
          onClick={onClose}
        />
      )}
      {buttonThree && (
        <ButtonGeneric
          style="buttonGenericCustom"
          title={buttonThree}
          colorTitle="#007BC0"
          onClick={onLogout}
        />
      )}
    </div>
  );
};
